import axios, { type AxiosResponse, type AxiosError } from 'axios';
import { BASE_URL } from './consts';

export const restorePassword = async (email: string): Promise<AxiosResponse | AxiosError> =>
  axios
    .post(`${BASE_URL}/restorepassword`, { email })
    .then((response) => response)
    .catch((error) => error);
